import React,{Component} from 'react'
import axios from 'axios';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import LoadingComponent from './LoadingComponent';   // 引入css
import '../css/app.css';   // 引入css
import { Base64 } from 'js-base64';
const host = `http://open.onethingcloud.com`

export default class App extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			detail: {},
			transactionList: [],
			fileList: [],
			showMoreBtn: false,
			takeUp: false,
			contractSourceCode: '',
			contractABI: '',
			contractCreationCode: '',
			contractSourceCodeCopied: false,
			contractABICopied: false,
			contractCreationCodeCopied: false,
			showModal: false,
			message: '',
			load: false
		}
		this.tradeHash = this.getUrlParam('tradeHash')
		this.contract = this.getUrlParam('contract') || '0x0a1a01b45445436ca3b810b93d10beac6e36267e'
		this.allFiles = []
	}
	componentDidMount(){
		//this.canvasMove();
		this.getTransactionList();
		this.getCode();
	}
	getContractDetail(transactionList,tradeHash, contract){
		for(let i=0;i<transactionList.length;i++){
			if(tradeHash === transactionList[i].hash){
				let detail = transactionList[i]
				detail.contract = contract
				detail.tradeHash = tradeHash
				this.setState({ detail });
				break
			}
		}
	}
	getTransactionList(){
		let _self = this;
		let contract = this.contract
		this.setState({load: true})
		axios({
			method:'get',
			url: `/api/partyConstructionContract/getTransactionList?contract=${contract}&page=1&pageSize=20`
		  })
		.then((response) => {
			this.setState({load: false})
			if(response.data.code === 0){
				let transactionList = response.data.data
				if(transactionList.length > 0){
					if(_self.tradeHash){
						for(let i=0;i<transactionList.length;i++){
							if(transactionList[i].hash === _self.tradeHash){
								_self.getContractDetail(transactionList,transactionList[i].hash, contract);
								transactionList[i].on = true
							}
						}
					}else{
						transactionList[0].on = true
						_self.getContractDetail(transactionList,transactionList[0].hash, contract);
					}

					_self.setState({ transactionList });
					let allFiles = transactionList		
					this.allFiles = allFiles
					if(allFiles.length > 6)	{		 
						_self.setState({ fileList: allFiles.slice(0,6), showMoreBtn: true })
					}else{
						_self.setState({ fileList: allFiles, showMoreBtn: false })
					}
				}
			}
		  })
		.catch((err) => {
			this.setState({load: false})
			console.log(err);	
		});
	}
	getCode(){
		let _self = this;
		let contract = this.contract
		axios({
			method:'get',
			url:`/api/partyConstructionContract/getContractCode`,
		  })
		.then((response) => {
			let data = response.data
			if( data.code === 0 ){	
				this.setState({	contractSourceCode: data.data.contractSourceCode,contractABI: data.data.contractABI, contractCreationCode: data.data.contractCreationCode})
			}
		  })
		.catch((err) => {
			console.log(err);
		});
	}
	// 对Date的扩展，将 Date 转化为指定格式的String
	// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
	// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
	// 例子：
	// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
	// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
	dateFormat(date, fmt) {
		if(!date){
			return null
		}
		let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds(),
		'q+': Math.floor((date.getMonth() + 3) / 3),
		'S': date.getMilliseconds()
		}
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
		for (let k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
		}
		return fmt
	}
	
	// 获取url参
	getUrlParam(key) {
		var reg = new RegExp(key + '=([^&]*)')
		var results = location.href.match(reg)
		return results ? results[1] : null
	}
	showDetail(i,hash){
		let transactionList = this.state.transactionList
		let contract = this.contract
		for(let i=0;i<transactionList.length;i++){
			transactionList[i].on = false
		}
		transactionList[i].on = true
		this.setState({transactionList})
		this.getContractDetail(transactionList,hash,contract);
	}
	showMore(){
		let len = this.state.fileList.length
		let allLen = this.allFiles.length
		let fileList = this.state.fileList
		if(len >= allLen){
			this.setState({showMoreBtn: false,takeUp: true})
		}else{
			this.setState({fileList: this.state.fileList.concat(this.allFiles.slice(len,len + 6))})
		}
	}
	takeUpList(){
		this.setState({fileList: this.state.fileList.slice(0,5), showMoreBtn: true,takeUp: false})
	}
	render(){
		const { detail, transactionList, fileList, load } = this.state
		return(
			<div className="">
				{load && <LoadingComponent/>}
				<div className="wave">
					<div className="page-slogan">
						<h3 style={{color: '#000'}}>{`区块链党建 迅雷党建活动`}</h3>
					</div>
				</div>
				<div className="bg-gray">
				    <div className="index-yjj">
						<div className="container">
							<div className="program-yjj">
								<div className="program-nav">
									<h2 className="program-nav-title">交易总览</h2>
									{
										transactionList.map((item,i)=>{
											return <div className={`program-nav-list ${item.on ? 'on':''}`}>
												<a href="javascript:void(0);" onClick={() => { this.showDetail(i,item.hash) }}>
													<h4>{item.fileName}</h4>
													<p>{item.fileHash}</p>
												</a>
											</div>
										})
									}
									
								</div>
								<div className="program-content"  style={{wordBreak: 'break-all'}}>
									<div className="program-content-header">
										<h3 className="program-content-title">{detail.fileName}</h3>
										<p>{detail.fileHash}</p>
									</div>
									<div className="program-content-main">
										<table className="program-content-table">
											<tbody>
												<tr>
													<td>交易哈希：</td>
													<td>{detail.tradeHash}</td>
												</tr>
												<tr>
													<td>入链时间：</td>
													<td>{detail.fromBlockTime ? this.dateFormat(new Date(Number(detail.fromBlockTime) * 1000), 'yyyy-MM-dd hh:mm:ss') : null}</td>
												</tr>
												<tr>
													<td>转出地址：</td>
													<td>{detail.from}</td>
												</tr>
												<tr>
													<td>转入地址：</td>
													<td>{detail.to}</td>
												</tr>
												<tr>
													<td>GAS消耗：</td>
													<td>{detail.gasUsed}</td>
												</tr>
												<tr>
													<td>合约地址：</td>
													<td>{detail.contract}</td>
												</tr>
												<tr>
													<td>所属机构：</td>
													<td>{detail.compony}</td>
												</tr>
												<tr>
													<td>合约描述：</td>
													<td>{detail.desc}</td>
												</tr>
												<tr>
													<td>文件描述：</td>
													<td>{detail.fileDesc}</td>
												</tr>
												<tr>
													<td>下载地址：</td>
													<td><a href={detail.fileUrl} target="view_window" className="link">{detail.fileUrl}</a></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="index-yjj">
						<div className="container">
							<h2 className="index-yjj-title">合约代码</h2>
							<div className="code-contorl">
								<div className="code-left">
									<span className="block-list"><i className="icon-code"></i><b>Contract Source Code</b></span>
								</div>
								<div className="code-right">
								<CopyToClipboard text={Base64.decode(this.state.contractSourceCode)}
									onCopy={()=>{this.setState({contractSourceCodeCopied: true,showModal: true,message:'复制成功'});setTimeout(()=>{this.setState({showModal: false,message:''})},1000)}}>
										<a href="javascript:void(0);" className="block-list"><i className="icon-copy"></i><b>复制</b></a>
								</CopyToClipboard>
									
								</div>
							</div>
							<div className="code-box">
								<pre style={{maxHeight:'400px'}}>
								<code>
									{Base64.decode(this.state.contractSourceCode)}
								</code>
								</pre>
							</div>
							<div className="code-contorl">
								<div className="code-left">
									<span className="block-list"><i className="icon-ABI"></i><b>Contract ABI</b></span>
								</div>
								<div className="code-right">
								<CopyToClipboard text={Base64.decode(this.state.contractABI)}
									onCopy={()=>{this.setState({contractABICopied: true,showModal: true,message:'复制成功'});setTimeout(()=>{this.setState({showModal: false,message:''})},1000)}}>
										<a href="javascript:void(0);" className="block-list"><i className="icon-copy"></i><b>复制</b></a>
								</CopyToClipboard>
								</div>
							</div>
							<div className="code-box">
								<pre style={{maxHeight:'400px'}}>
									<code>
										{Base64.decode(this.state.contractABI)}
									</code>
								</pre>
							</div>
							<div className="code-contorl">
								<div className="code-left">
									<span className="block-list"><i className="icon-list"></i><b>Contract Creation Code</b></span>
								</div>
								<div className="code-right">
								<CopyToClipboard text={Base64.decode(this.state.contractCreationCode)}
									onCopy={()=>{this.setState({contractCreationCodeCopied: true,showModal: true,message:'复制成功'});setTimeout(()=>{this.setState({showModal: false,message:''})},1000)}}>
										<a href="javascript:void(0);" className="block-list"><i className="icon-copy"></i><b>复制</b></a>
								</CopyToClipboard>
								</div>
							</div>
							<div className="code-box nomargin">
								<pre style={{maxHeight:'400px'}}>
									<code>
										{Base64.decode(this.state.contractCreationCode)}
									</code>
								</pre>
							</div>
						</div>
					</div>
					<div className="index-yjj">
						<div className="container">
							<h2 className="index-yjj-title">文件下载</h2>
							<div className="file-download">
								<table className="file-table">
									<thead>
										<tr>
											<th>文件名</th>
											<th>文件哈希值</th>
											<th>入链时间</th>
										</tr>
									</thead>
									<tbody>
										{
											fileList.map((item,i)=>{
												return <tr>
												<td>{item.fileName}</td>
												<td><a href={item.fileUrl} target="view_window" className="link">{item.fileHash}</a></td>
												<td>{this.dateFormat(new Date(Number(item.fromBlockTime) * 1000), 'yyyy-MM-dd hh:mm:ss')}</td>
											</tr>
											})
										}
									</tbody>
								</table>
								<div className="load-box">
									{
										this.state.showMoreBtn ? <a href="javascript:void(0);" onClick={this.showMore.bind(this)} className="btn-load">查看更多</a>:
										<span className="no-more">没有更多了</span>
									}
									{
										this.state.takeUp ? <a style={{display: 'block',margin: '0 auto'}} href="javascript:void(0);" onClick={this.takeUpList.bind(this)} className="btn-load">收起</a> : null
									}
								</div>
							</div>
						</div>
					</div>
				</div>
				{
				this.state.showModal && <div style={{position:'fixed', width:'160px',height:'40px',textAlign:'center',fontSize:'18px',lineHeight:'40px',color:'#fff',background:'rgba(0,0,0,.5)', top:'50%',left:'50%',transform: 'translate(-50%, -50%)'}}>  
					<p>{this.state.message}</p>
				</div> 
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/party/pages/App.js